export const useHasIcons = (propertiesList, countryCode, icons) => {
    if (!icons)
        return false;
    return propertiesList.some((property) => {
        const iconKey = property.replace(".", "_");
        return icons[`${iconKey}_${countryCode}`] || icons[iconKey];
    });
};
